module.exports = __webpack_public_path__ + "static/media/hiw-icon-true-offer.fe1891c8.webp";